import script from "./ConfigScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigScreen.vue?vue&type=script&setup=true&lang=js"

import "./ConfigScreen.vue?vue&type=style&index=0&id=ef6d8098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef6d8098"]])

export default __exports__